import type { RouteRecordRaw } from 'vue-router'

export const assignmentsRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/AssignmentsToolView.vue'),
    meta: {
      title: 'tools.assignments',
    },
    name: 'brand.tools.assignments',
    path: 'assignments',
  },
]
